'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _nuiShell = require('@concur/nui-shell');

var _listingsModule = require('../listings/listingsModule');

var _listingsModule2 = _interopRequireDefault(_listingsModule);

var _listingModule = require('../listing/listingModule');

var _listingModule2 = _interopRequireDefault(_listingModule);

var _termsModule = require('../terms/termsModule');

var _termsModule2 = _interopRequireDefault(_termsModule);

var _userProfileModule = require('../userProfile/userProfileModule');

var _userProfileModule2 = _interopRequireDefault(_userProfileModule);

var _utilsModule = require('../utils/utilsModule');

var _utilsModule2 = _interopRequireDefault(_utilsModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)(_extends({
  listings: _listingsModule2.default,
  listing: _listingModule2.default,
  terms: _termsModule2.default,
  userProfile: _userProfileModule2.default,
  meta: _utilsModule2.default
}, _nuiShell.reducers));


//////////////////
// WEBPACK FOOTER
// ./lib/app/rootReducer.js
// module id = 414
// module chunks = 0